import AumHeader from './components/AumHeader';
import HeroSection from './components/HeroSection';
import LivingTreeSection from './components/LivingTreeSection';
import TrilogySection from './components/TrilogySection';
import StartHereSection from './components/StartHereSection';
import InitiatorSection from './components/InitiatorSection';
import CosmicLibrarySection from './components/CosmicLibrarySection';
import PortalSection from './components/PortalSection';
import AxionUtopiaSection from './components/AxionUtopiaSection';
import AboutAumSection from './components/AboutAumSection';
import FinalCtaSection from './components/FinalCtaSection';
import AumFooter from './components/AumFooter';

export default function AumHome() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-900">
      <AumHeader />
      <main>
        <HeroSection />
        <LivingTreeSection />
        <TrilogySection />
        <StartHereSection />
        <InitiatorSection />
        <CosmicLibrarySection />
        <PortalSection />
        <AxionUtopiaSection />
        <AboutAumSection />
        <FinalCtaSection />
      </main>
      <AumFooter />
    </div>
  );
}
